module.exports = __webpack_public_path__ + "15aff0fe68fc605110cc68cbb76d138e.svg";